import Layouts from 'Layouts'
import InstagramLayout from 'Layouts/instagram'
import {
   AddChannel,
   Dashboard,
   DownloadPdfReport,
   Login,
   PrivacyPolicy,
   Profile,
   TermsCondition,
   VideoAnalysis,
   Videos,
   Welcome
} from 'pages'
import {
   InDashboard,
   InstagramAuth,
   InstagramLogin,
   PostReelDetails,
   PostsReels
} from 'pages/Instagram'
import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

export default function Routers() {
   const location = useLocation()
   return (
      <Routes>
         <Route path="/auth/login" element={<Login />} />
         <Route path="/auth/add-channel" element={<AddChannel />} />
         <Route path="/auth/welcome" element={<Welcome />} />
         <Route path="/instagram" element={<Navigate to={`/instagram/login`} />} />
         <Route path="/instagram/login" element={<InstagramLogin />} />
         <Route path="/instagram-auth" element={<InstagramAuth />} />
         {/* YouTub */}
         <Route path="/" element={<Layouts />}>
            <Route index element={<Navigate to={`/dashboard${location?.search}`} />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/videos/analysis/:id" element={<VideoAnalysis />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<></>} />
         </Route>
         {/* Instagram */}
         <Route path="/" element={<InstagramLayout />}>
            <Route index element={<Navigate to={`/instagram/dashboard`} />} />
            <Route path="/instagram/dashboard" element={<InDashboard />} />
            <Route path="/instagram/posts-reel/:id" element={<PostReelDetails />} />
            <Route path="/instagram/posts-reel" element={<PostsReels />} />
            <Route path="*" element={<></>} />
         </Route>

         <Route path="/videos/analysis/report/:id" element={<DownloadPdfReport />} />
         <Route path="terms-condition" element={<TermsCondition />} />
         <Route path="privacy-policy" element={<PrivacyPolicy />} />
         <Route path="*" element={<></>} />
      </Routes>
   )
}
